import {sharedModule} from '../shared/shared.module';
import {loginModule} from '../login/login.module';

import {landingRoutes} from './landing.routes';

import {FlowService} from './flow.service';
import {ChooseMechanismService} from './choose-mechanism.service';
import {FlowStateService} from './FlowStateService';

export var landingModule = angular.module('authentication.landing', [
        'pascalprecht.translate',
        'ui.router',
        'ngResource',
        sharedModule.name,
        loginModule.name
    ])
    .config(landingRoutes)
    .service('flowService', FlowService)
    .service('flowStateService', FlowStateService)
    .service('chooseMechanismService', ChooseMechanismService)
    ;
